module.exports = __webpack_public_path__ + "img/image-example-table-alike-transformed.65f10828.png";